firebird.directive('lobbyPageFooter', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(helperService.getRedesignPathPrefix() + 'lobbyPageFooter.html'),
            link: function (scope, element, attrs, ngCtrl) {}
        };
    }
]);
